import script from "./EstoqueProdutos.vue?vue&type=script&setup=true&lang=js"
export * from "./EstoqueProdutos.vue?vue&type=script&setup=true&lang=js"

import "./EstoqueProdutos.vue?vue&type=style&index=0&id=5f87e4f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f87e4f3"]])

export default __exports__